// JOBE-0166.2: formatMetricValue — pure utility for metric value display.
// Used by MetricRow (current + target columns), Spark tooltip (JOBE-0166.4),
// and metricStatus logic (JOBE-0166.3).

/**
 * Format a numeric metric value for display.
 * @param {number} value
 * @param {'ratio'|'ms'|'count'} unit
 * @returns {string}
 */
export function formatMetricValue(value, unit) {
  if (value === null || value === undefined) return '—';
  if (unit === 'ratio') {
    return `${(value * 100).toFixed(1)}%`;
  }
  if (unit === 'ms') {
    return `${value.toLocaleString()} ms`;
  }
  // count
  return `${value}`;
}
